
/**
 * ドロップダウンボックスの開閉
 **/
$(function(){

  var active_item = null;


  function clearDropDowns() {
    if ( active_item ) {
      active_item.slideUp(1);
      active_item = null;
      return true;
    }
    return false;
  }

  $('.dropdown-toggle').on('click', function() {
    target_item = $(this).next();
    if ( target_item.is(active_item) ) {
      clearDropDowns();
      return;
    }

    clearDropDowns();
    target_item.slideDown(300);
    active_item = target_item;
  });


  //入力フォームが選択されると開いているドロップダウンは閉じるようにする
  $('.search-field').click(function() {
    $('.dropdown-toggle').next().slideUp();
  });
});
